module.exports = __webpack_public_path__ + "img/jazzy-cover-fallback-groove.38311b5.jpg";